import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-phone\">\n  <g fill=\"currentColor\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.4,4H7.6C6.61,4,5.8,4.81,5.8,5.8v8.4c0,0.99,0.81,1.8,1.8,1.8h4.8\n\t\tc0.99,0,1.8-0.81,1.8-1.8V5.8C14.2,4.81,13.39,4,12.4,4z M10.6,15.4H9.4v-1.2h1.2V15.4z M13,13.6H7V6.4h6V13.6z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol